// =================== HOW TO CITE ===================================
document.addEventListener("DOMContentLoaded", getPlainTextContent);
document.addEventListener("DOMContentLoaded", getDownloadURL);

let copyPasteArea = document.getElementById("copyPasteArea");
let fileFormatGroup = document.querySelectorAll("input[name='fileFormat']");
let includeTypeGroup = document.querySelectorAll("input[name='includeType']");

fileFormatGroup.forEach((element) => {
    element.addEventListener("change", function(event) {
        getPlainTextContent();
        getDownloadURL();
    });
});

includeTypeGroup.forEach((element) => {
    element.addEventListener("change", function(event) {
        getPlainTextContent();
        getDownloadURL();
    });
});

function getDownloadURL() {
    let fileFormat = document.querySelector("input[name='fileFormat']:checked").value;
    let includeType = document.querySelector("input[name='includeType']:checked").value;

    let contentPath = includeType === "cit" ? "citation" : "references";
    let pathname = window.location.pathname;
    let journalName = pathname.split("/")[1];
    let downloadURL = `/${journalName}/content/${contentPath}/${currentPid}-${includeType}.${fileFormat}`;
    let downloadLink = document.getElementById("citation-download");

    downloadLink.setAttribute("href", downloadURL);
    downloadLink.setAttribute("target", "_blank");
}

function getPlainTextContent() {
    let fileFormat = document.querySelector("input[name=\"fileFormat\"]:checked").value;
    let includeType = document.querySelector("input[name=\"includeType\"]:checked").value;

    let contentPath = includeType === "cit" ? "citation-txt" : "references-txt";
    let pathname = window.location.pathname;
    let journalName = pathname.split("/")[1];

    let ajaxURL = `/${journalName}/content/${contentPath}/${currentPid}-${includeType}.${fileFormat}`;

    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            copyPasteArea.innerHTML = this.responseText;
        }
    };

    xhttp.open("GET", ajaxURL, true);
    xhttp.send();
}


// ============================ DOWNLOAD TOC =====================================

const tocItemList = new Map();
tocItemList.set("suppInfo", "Supporting Information");
tocItemList.set("howToCite", "How to Cite");
tocItemList.set("adds-corrs", "Adds. & Corrs.");
tocItemList.set("presentationGraphic", "Presentation Graphic");
tocItemList.set("citedBy", "Cited By");

let tocItems = document.querySelectorAll(".js-download-toc-item");
let downloadTocList = document.getElementById("download-toc-list");

for (let i = 0; i < tocItems.length; i++) {
    let tocItem = tocItems[i].id;

    let a = document.createElement("a");
    a.setAttribute("href", "#" + tocItem);
    a.classList.add("text-bs");
    a.classList.add("text-white");
    a.classList.add("hover:underline");
    a.appendChild(document.createTextNode(tocItemList.get(tocItem)));

    let li = document.createElement("li");
    li.appendChild(a);

    downloadTocList.appendChild(li);
}
